// -----------------------------------------------------------------------------
// Block type identifiers
// -----------------------------------------------------------------------------

export const BLOCK_TYPES = [
  'guided_conversation',
  'vocabulary_grid',
  'fill_in_the_blank',
  'translation_challenge',
  'conjugation_spotlight',
  'reading_comprehension',
  'matching_exercise',
  'scenario_prompts',
  'grammar_explanation',
] as const;

export type BlockType = (typeof BLOCK_TYPES)[number];

// -----------------------------------------------------------------------------
// Block metadata — drives UI rendering, composition rules, and admin display
// -----------------------------------------------------------------------------

export interface BlockMeta {
  name: string;
  emoji: string;
  estimatedPages: number;
  isFavorite: boolean;
  color: string;
}

export const BLOCK_META: Record<BlockType, BlockMeta> = {
  guided_conversation: {
    name: 'Guided Conversation',
    emoji: '💬',
    estimatedPages: 2,
    isFavorite: false,
    color: '#4A6FA5',
  },
  vocabulary_grid: {
    name: 'Vocabulary Grid',
    emoji: '📝',
    estimatedPages: 1.5,
    isFavorite: true,
    color: '#2C98D4',
  },
  fill_in_the_blank: {
    name: 'Fill in the Blank',
    emoji: '✏️',
    estimatedPages: 1,
    isFavorite: true,
    color: '#7C3AED',
  },
  translation_challenge: {
    name: 'Translation Challenge',
    emoji: '🔄',
    estimatedPages: 1.5,
    isFavorite: false,
    color: '#C06020',
  },
  conjugation_spotlight: {
    name: 'Conjugation Spotlight',
    emoji: '🔦',
    estimatedPages: 2,
    isFavorite: false,
    color: '#DC2626',
  },
  reading_comprehension: {
    name: 'Reading Comprehension',
    emoji: '📖',
    estimatedPages: 2,
    isFavorite: true,
    color: '#0D9488',
  },
  matching_exercise: {
    name: 'Matching Exercise',
    emoji: '🔗',
    estimatedPages: 1,
    isFavorite: true,
    color: '#4338CA',
  },
  scenario_prompts: {
    name: 'What Would You Say?',
    emoji: '🗣️',
    estimatedPages: 1.5,
    isFavorite: false,
    color: '#D97706',
  },
  grammar_explanation: {
    name: 'Grammar Explanation',
    emoji: '📐',
    estimatedPages: 1.5,
    isFavorite: false,
    color: '#8B5CF6',
  },
};

// -----------------------------------------------------------------------------
// Vocabulary Grid — universal tip shown below every grid (keyed by source lang)
// -----------------------------------------------------------------------------

export const VOCABULARY_GRID_TIP: Record<string, string> = {
  en: 'Use a dictionary or the internet to look up the missing words.',
  nl: 'Gebruik een woordenboek of het internet om de ontbrekende woorden op te zoeken.',
};
